import { Component, Input, OnChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { I18NextModule } from 'angular-i18next';

@Component({
  selector: 'app-reactive-text-input',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, I18NextModule],
  templateUrl: './reactive-text-input.component.html',
  styleUrls: ['./reactive-text-input.component.scss'],
})
export class ReactiveTextInputComponent implements OnChanges {
  @Input() label: string = '';
  @Input() type: string = 'text';
  @Input() id: string = '';
  @Input() control: FormControl = new FormControl();
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() errorMessage: string = 'Something is wrong!';
  @Input() reference: string = '';
  @Input() minNum: number = 10;
  @Input() maxNum: number = 12;
  @Input() isTaxId: boolean = false;

  ngOnChanges(): void {
    const validators = [];
    if (this.required) {
      validators.push(Validators.required);
    }
    if (this.isTaxId) validators.push(this.taxIdValidator.bind(this));
    if (this.reference === 'bank-number') {
      validators.push(this.bankNumberValidator.bind(this));
    }
    this.control.setValidators(validators);
    this.control.updateValueAndValidity(); // Trigger validation
  }

  taxIdValidator(control: AbstractControl): ValidationErrors | null {
    let value = control.value;

    let sanitizedValue = value;

    console.log(value, sanitizedValue);

    if (this.isTaxId) {
      sanitizedValue = sanitizedValue.replace(/\s|-/g, '');
    }

    const regex = new RegExp(`^\\d{${this.minNum},${this.maxNum}}$`);
    const valid = regex.test(sanitizedValue);

    return valid ? null : { taxIdInvalid: true };
  }

  bankNumberValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const regex = new RegExp(`^\\d{${this.minNum},${this.maxNum}}$`);
    const valid = regex.test(value);
    return valid ? null : { bankNumberInvalid: true };
  }

  public handleKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Delete'];

    const key = event.key;

    if (allowedKeys.includes(key)) return;

    if (this.isTaxId && !/^[0-9]$/.test(key)) {
      event.preventDefault();
    }
  }

  public handleInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    if (this.isTaxId) {
      value = value.replace(/[^0-9]/g, '');
    }

    input.value = value;
    this.control.setValue(value, { emitEvent: false });
  }
}
